import { render, staticRenderFns } from "./AppHotelInfoCard.vue?vue&type=template&id=07b17ba6&scoped=true&"
import script from "./AppHotelInfoCard.vue?vue&type=script&lang=js&"
export * from "./AppHotelInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./AppHotelInfoCard.vue?vue&type=style&index=0&id=07b17ba6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b17ba6",
  null
  
)

export default component.exports